import { homeFilled, tutorIcons } from "../../../assets";
import ProfileView from './../../../pages/ProfileView'
import MainProfileView from './../../../pages/MainProfileView'
import Verification from "../../../pages/SetProfile/Verification";
import EmailVer from "../../../pages/SetProfile/Verification/EmailVer";
import NumVer from "../../../pages/SetProfile/Verification/NumVer";
import NumCode from "../../../pages/SetProfile/Verification/NumVer/SendCode";
import EmailCode from "../../../pages/SetProfile/Verification/EmailVer/SendCode";
import Number from "../../../pages/RepairPass/Number";
import Emaill from "../../../pages/RepairPass/Email";
import Login from "../../../pages/Login/Login";
import RepairPass from "../../../pages/RepairPass";
import Language from "../../../pages/Language";
import Register from "../../../pages/SetProfile";
import SettingProfData from "../../../pages/SetProfile/SettingProfileData";
import Portfolio from "../../../pages/Portfolio";
import EditProfile from "../../../pages/MainProfileView/EditProfile";
import Followers from "../../../pages/Followers";
import Lessons from "../../../pages/Lessons";
import Explore from "../../../pages/Explore";
import Search from "../../../pages/Search";
import Toplam from "../../../pages/Toplam";
import Toplamlar from "../../../pages/Toplam/Toplamlar";
import About from "../../../pages/About";
import Chats from "../../../pages/Chats";
import Newpost from "../../../pages/Newpost";
import Saved from "../../../pages/Saved";
import Chat from "./../../Message/Chat";

export const login =[
    {
        path: 'verification',
        component: <Verification/>
    },
    {
        path: 'settingprofdata',
        component: <SettingProfData/>
    },
    {
        path: 'register',
        component: <Register/>
    },
    {
        path: 'emailver',
        component: <EmailVer/>
    },
    {
        path: 'numver',
        component: <NumVer/>
    },
    {
        path: 'vercode',
        component: <NumCode/>
    },
    {
        path: 'emailcode',
        component: <EmailCode/>
    },
    {
        path: 'repairnum',
        component: <Number/>
    },
    {
        path: 'repairemail',
        component: <Emaill/>
    },
    {
        path: 'login',
        component: <Login/>
    },
    {
        path: 'repair',
        component: <RepairPass/>
    },
    {
        path: 'language',
        component: <Language/>
    },
]

export const pages =[
    {
        hidden: false,
        icon: tutorIcons.home,
        iconActive: homeFilled,
        path: '',
        name: "Home",
        component:  <Explore/>
        
    },
    {
        hidden: true,
        path: 'editprofile',
        component: <EditProfile/>
    },
    {
        hidden: true,
        path: 'user',
        component: <ProfileView/>
    },
    {
        hidden: true,
        path: 'message',
        component: <Chats/>
    },
    {
        hidden: true,
        path: 'Chat',
        component: <Chat/>
    },
    {
        hidden: true,
        path: 'about',
        component: <About/>
    },
    {
        hidden: true,
        path: 'start',
        component: <Explore/>
    },
    {
        hidden: true,
        path: 'followers',
        component: <Followers/>
    },
    {
        hidden: true,
        path: 'portfolio',
        component:  <Portfolio/>
    },
    {
        hidden: true,
        path: 'lessons',
        component:  <Lessons/>
    },
    {
        hidden: true,
        path: 'toplam',
        component:  <Toplam/>
    },
    {
        hidden: true,
        path: 'toplamlar',
        component:  <Toplamlar/>
    },
    {
        icon: tutorIcons.search,
        path: 'search',
        hidden: false,
        name: "Search",
        component:  <Search/>
    },
    {
        icon: tutorIcons.add,
        hidden: false,
        path: 'add',
        name: "Publicate",
        component:  <Newpost/>
    },
    {
        icon: tutorIcons.star,
        hidden: false,
        path: 'saved',
        name: "Saved",
        component:  <Saved/>
    },
    {
        icon: tutorIcons.user,
        hidden: false,
        path: 'profile',
        name: "Profile",
        component:  <MainProfileView/>
    },
]